import { testimonials } from '@/mocks/yy';

const principles = [
  { icon: 'ri-compass-3-line', title: '官网直达', desc: '只汇总真实可用的官方入口与地址，让用户少走弯路。' },
  { icon: 'ri-hand-heart-line', title: '简单好用', desc: '用最直白的语言讲解入口、登录与使用，新用户也能轻松上手。' },
  { icon: 'ri-shield-check-line', title: '安全提示', desc: '提醒用户通过官方渠道登录与充值，远离非正规入口。' },
];

export default function About() {
  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-information-line" aria-hidden="true"></i>
              关于本站
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950">为每一次直达，节省每一秒</h2>
            <p className="mt-5 text-foreground-700 text-sm md:text-base leading-relaxed">
              本站是歪歪官方网站的入口导航站点，专注为用户梳理歪歪官方网站入口、地址、首页、网址与登录方式。我们相信，找对一个入口，能让每一次娱乐时光都更顺畅。
            </p>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              我们持续整理平台的最新入口与使用指引，帮助新老用户快速上手。无论你是第一次接触，还是已经使用多年，都能在这里找到有用的信息。
            </p>

            <div className="mt-8 flex flex-col gap-4">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-4 rounded-lg bg-background-50 border border-background-200 p-5">
                  <span className="inline-flex w-10 h-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${p.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="text-base text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xl md:text-2xl text-foreground-950 font-heading">用户的声音</h3>
            <p className="mt-3 text-foreground-700 text-sm md:text-base">来自不同场景用户的真实使用体验，帮助我们不断优化这份入口指南。</p>
            <div className="mt-6 flex flex-col gap-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-lg bg-background-50 border border-background-200 p-6">
                  <div className="flex items-center gap-1 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-4 text-sm md:text-base text-foreground-800 leading-relaxed">
                    "{t.quote}"
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-user-line" aria-hidden="true"></i>
                    </span>
                    <div>
                      <p className="text-sm text-foreground-950 font-medium">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}